import Reveal from "@/components/Reveal";
import ContactForm from "@/components/ContactForm";
import Seo from "@/components/Seo";
import { HOTEL } from "@/data/hotel";
import { trackEvent } from "@/lib/analytics";

const trackContact = (channel) => () => trackEvent("contact_click", { channel, placement: "contact_page" });

export default function Contact() {
  return (
    <div className="pt-32 md:pt-40 pb-24">
      <Seo
        title="Contact — Reservations & Enquiries"
        description="Get in touch with Hotel Azulo Inn — B1/16 Safdarjung Enclave, New Delhi. Reservations: 011-42603179. Email reservation@azulohotels.com. 24/7 front desk."
        path="/contact"
      />
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid md:grid-cols-12 gap-16">
        <div className="md:col-span-5">
          <Reveal>
            <div className="overline">Get in touch</div>
            <h1 className="mt-6 font-serif text-5xl md:text-6xl leading-[0.98] text-ink-900">
              Write to our
              <span className="italic text-sage-dark"> front desk.</span>
            </h1>
            <p className="mt-8 max-w-sm text-ink-700 leading-relaxed">
              For reservations, restaurant enquiries, event bookings, or anything Hotel Azulo Inn
              can arrange for you in New Delhi.
            </p>
          </Reveal>

          <div className="mt-14 space-y-8">
            <div>
              <div className="overline">Address</div>
              <div className="mt-3 text-ink-800">{HOTEL.address}</div>
            </div>
            <div>
              <div className="overline">Telephone</div>
              <a href={`tel:${HOTEL.phone.replace(/\s|-/g, "")}`} data-testid="contact-phone" onClick={trackContact("phone")} className="mt-3 block text-ink-800 hover:text-sage-dark">
                {HOTEL.phone}
              </a>
              <a href={`tel:${HOTEL.mobile.replace(/\s|-|\+/g, "")}`} data-testid="contact-mobile" onClick={trackContact("phone")} className="mt-1 block text-ink-800 hover:text-sage-dark">
                {HOTEL.mobile}
              </a>
            </div>
            <div>
              <div className="overline">Email</div>
              <a href={`mailto:${HOTEL.email}`} data-testid="contact-email" className="mt-3 block text-ink-800 hover:text-sage-dark">
                {HOTEL.email}
              </a>
            </div>
            <div>
              <div className="overline">Nearby</div>
              <div className="mt-3 text-sm text-ink-700 space-y-1">
                <div>Bhikaji Cama Place Metro · 1.1 km</div>
                <div>IGI Airport · 9 km</div>
                <div>New Delhi Railway · 11.8 km</div>
              </div>
            </div>
          </div>
        </div>

        <div className="md:col-span-7 md:pl-10 md:border-l hairline">
          <ContactForm />
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 mt-20">
        <Reveal>
          <div className="overline">Find us</div>
          <h2 className="mt-4 font-serif text-2xl md:text-3xl text-ink-900">
            B1/16 Safdarjung Enclave, <span className="italic text-sage-dark">New Delhi</span>
          </h2>
          <div className="mt-8 border hairline overflow-hidden" data-testid="contact-map">
            <iframe
              title="Hotel Azulo Inn — B1/16 Safdarjung Enclave, New Delhi"
              src="https://www.google.com/maps?q=Hotel%20Azulo%20Inn%2C%20B1%2F16%20Safdarjung%20Enclave%2C%20New%20Delhi%20110029&output=embed"
              width="100%"
              height="420"
              style={{ border: 0, display: "block" }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </Reveal>
      </div>
    </div>
  );
}
